export const webClientId = '878520898236-r8sg8j04gmj6pfoeamu7gqpqittft4n2.apps.googleusercontent.com'